import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const businessUnreadCounts = gql`
  query BusinessUnreadCountsQuery {
    me {
      id
      businesses {
        id
        unreadCount
      }
    }
  }
`;

export const inviteLink = gql`
  query BusinessInviteLinkQuery($businessId: Int!) {
    me {
      id
      fullName
      inviteCode: shareCode(businessId: $businessId)
      business(businessId: $businessId) {
        id
        name
      }
    }
  }
`;

export const find = gql`
  query BusinessQuery($businessId: Int!) {
    me {
      id
      isBusinessAdmin(businessId: $businessId)
      role(businessId: $businessId)
    }
    business: myBusiness(businessId: $businessId) {
      ...Business
    }
  }

  ${Fragments.business.business}
`;
